import { fileMixin } from './FileMixin';

export var fileMixinModel = {
    mixins: [fileMixin],
    data: () => ({
        modelData: { path: '', name: '' },
        modelOptional: false,
        modelFiles: [],
        modelTypes: ['.glb'],
        modelValid: true
    }),
    computed: {
        modelRules: function () {
            return [
                value => {
                    let required = !(this.modelOptional || !(!value || (Array.isArray(value) && !value[0])));
                    return required ? 'Fichier requis' : true;
                },
                value => {
                    let extension = value ? this.getExtension(value.name) : '';
                    let allTypes = this.modelTypes.reduce((acc, item) => acc + ' *' + item, '');
                    let required = !(this.modelOptional && extension === '');
                    let extensionValid = !this.modelTypes.includes('.' + extension);
                    return required && extensionValid ? 'Formats attendus:' + allTypes : true;
                },
                value => {
                    let required = !(this.modelOptional && !value);
                    let validSize = !(value && value.size < 4000000);
                    return required && validSize ? 'La taille du fichier doit être inférieur à 4 MB!' : true;
                }
            ];
        }
    },
    methods: {
        initModelFiles: function (file, path, optional = false) {
            this.modelOptional = optional;
            if (file && file.path !== '') {
                this.createFile(path + file.path, file.name).then((data) => {
                    this.modelFiles = data;
                    this.fileValid = this.validateModel(this.modelFiles);
                });
            }
        },
        validateModel: function (model) {
            return this.modelRules.reduce((acc, item) => acc && item(model) && typeof item(model) !== 'string', true);
        },
        onChangeModel: function (model) {
            if (!model && this.modelOptional) {
                this.modelData = { path: '', name: '' };
                this.modelValid = true;
                return;
            }
            this.modelValid = this.validateModel(model);
            this.onChangeFile(model, this.modelValid).then((data) => {
                this.modelFiles = data.file;
                this.modelData = data.shortFile;
            }).catch((err, data) => {
                this.$toasted.error(err);
                this.modelData = data;
            });
        }
    }
};
